/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, utils } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_perpsMarketProxy",
                type: "address",
            },
            {
                internalType: "address",
                name: "_spotMarketProxy",
                type: "address",
            },
            {
                internalType: "address",
                name: "_sUSDProxy",
                type: "address",
            },
            {
                internalType: "address",
                name: "_oracle",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "_pythPriceFeedIdEthUsd",
                type: "bytes32",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "CannotExecuteOrder",
        type: "error",
    },
    {
        inputs: [],
        name: "Unauthorized",
        type: "error",
    },
    {
        inputs: [],
        name: "DOMAIN_SEPARATOR",
        outputs: [
            {
                internalType: "bytes32",
                name: "separator",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "uint128",
                                name: "marketId",
                                type: "uint128",
                            },
                            {
                                internalType: "uint128",
                                name: "accountId",
                                type: "uint128",
                            },
                            {
                                internalType: "int128",
                                name: "sizeDelta",
                                type: "int128",
                            },
                            {
                                internalType: "uint128",
                                name: "settlementStrategyId",
                                type: "uint128",
                            },
                            {
                                internalType: "uint256",
                                name: "acceptablePrice",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct IEngine.OrderDetails",
                        name: "orderDetails",
                        type: "tuple",
                    },
                    {
                        internalType: "address",
                        name: "signer",
                        type: "address",
                    },
                    {
                        internalType: "uint128",
                        name: "nonce",
                        type: "uint128",
                    },
                    {
                        internalType: "bool",
                        name: "requireVerified",
                        type: "bool",
                    },
                    {
                        internalType: "address",
                        name: "trustedExecutor",
                        type: "address",
                    },
                    {
                        internalType: "bytes[]",
                        name: "conditions",
                        type: "bytes[]",
                    },
                ],
                internalType: "struct IEngine.ConditionalOrder",
                name: "_co",
                type: "tuple",
            },
            {
                internalType: "bytes",
                name: "_signature",
                type: "bytes",
            },
        ],
        name: "canExecute",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint128",
                name: "_perpsMarketId",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "_accountId",
                type: "uint128",
            },
            {
                internalType: "int128",
                name: "_sizeDelta",
                type: "int128",
            },
            {
                internalType: "uint128",
                name: "_settlementStrategyId",
                type: "uint128",
            },
            {
                internalType: "uint256",
                name: "_acceptablePrice",
                type: "uint256",
            },
        ],
        name: "commitOrder",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "settlementTime",
                        type: "uint256",
                    },
                    {
                        components: [
                            {
                                internalType: "uint128",
                                name: "marketId",
                                type: "uint128",
                            },
                            {
                                internalType: "uint128",
                                name: "accountId",
                                type: "uint128",
                            },
                            {
                                internalType: "int128",
                                name: "sizeDelta",
                                type: "int128",
                            },
                            {
                                internalType: "uint128",
                                name: "settlementStrategyId",
                                type: "uint128",
                            },
                            {
                                internalType: "uint256",
                                name: "acceptablePrice",
                                type: "uint256",
                            },
                            {
                                internalType: "bytes32",
                                name: "trackingCode",
                                type: "bytes32",
                            },
                            {
                                internalType: "address",
                                name: "referrer",
                                type: "address",
                            },
                        ],
                        internalType: "struct IPerpsMarketProxy.OrderCommitmentRequest",
                        name: "request",
                        type: "tuple",
                    },
                ],
                internalType: "struct IPerpsMarketProxy.Data",
                name: "retOrder",
                type: "tuple",
            },
            {
                internalType: "uint256",
                name: "fees",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "createAccount",
        outputs: [
            {
                internalType: "uint128",
                name: "accountId",
                type: "uint128",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "eip712Domain",
        outputs: [
            {
                internalType: "bytes1",
                name: "fields",
                type: "bytes1",
            },
            {
                internalType: "string",
                name: "name",
                type: "string",
            },
            {
                internalType: "string",
                name: "version",
                type: "string",
            },
            {
                internalType: "uint256",
                name: "chainId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "verifyingContract",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "salt",
                type: "bytes32",
            },
            {
                internalType: "uint256[]",
                name: "extensions",
                type: "uint256[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "uint128",
                                name: "marketId",
                                type: "uint128",
                            },
                            {
                                internalType: "uint128",
                                name: "accountId",
                                type: "uint128",
                            },
                            {
                                internalType: "int128",
                                name: "sizeDelta",
                                type: "int128",
                            },
                            {
                                internalType: "uint128",
                                name: "settlementStrategyId",
                                type: "uint128",
                            },
                            {
                                internalType: "uint256",
                                name: "acceptablePrice",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct IEngine.OrderDetails",
                        name: "orderDetails",
                        type: "tuple",
                    },
                    {
                        internalType: "address",
                        name: "signer",
                        type: "address",
                    },
                    {
                        internalType: "uint128",
                        name: "nonce",
                        type: "uint128",
                    },
                    {
                        internalType: "bool",
                        name: "requireVerified",
                        type: "bool",
                    },
                    {
                        internalType: "address",
                        name: "trustedExecutor",
                        type: "address",
                    },
                    {
                        internalType: "bytes[]",
                        name: "conditions",
                        type: "bytes[]",
                    },
                ],
                internalType: "struct IEngine.ConditionalOrder",
                name: "_co",
                type: "tuple",
            },
            {
                internalType: "bytes",
                name: "_signature",
                type: "bytes",
            },
        ],
        name: "execute",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint128",
                name: "nonce",
                type: "uint128",
            },
        ],
        name: "executedOrders",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint128",
                name: "_accountId",
                type: "uint128",
            },
        ],
        name: "getAccountStats",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "totalFees",
                        type: "uint256",
                    },
                    {
                        internalType: "uint128",
                        name: "totalVolume",
                        type: "uint128",
                    },
                    {
                        internalType: "uint128",
                        name: "totalTrades",
                        type: "uint128",
                    },
                ],
                internalType: "struct IEngine.AccountStats",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint128",
                name: "_accountId",
                type: "uint128",
            },
            {
                internalType: "address",
                name: "_caller",
                type: "address",
            },
        ],
        name: "isAccountDelegate",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint128",
                name: "_accountId",
                type: "uint128",
            },
            {
                internalType: "address",
                name: "_caller",
                type: "address",
            },
        ],
        name: "isAccountOwner",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "market",
                type: "address",
            },
        ],
        name: "isMarketClosed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "market",
                type: "address",
            },
        ],
        name: "isMarketPaused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "price",
                type: "uint256",
            },
        ],
        name: "isPriceAbove",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "price",
                type: "uint256",
            },
        ],
        name: "isPriceBelow",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_timestamp",
                type: "uint256",
            },
        ],
        name: "isTimestampAfter",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_timestamp",
                type: "uint256",
            },
        ],
        name: "isTimestampBefore",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint128",
                name: "_accountId",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "_synthMarketId",
                type: "uint128",
            },
            {
                internalType: "int256",
                name: "_amount",
                type: "int256",
            },
        ],
        name: "modifyCollateral",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "data",
                type: "bytes[]",
            },
        ],
        name: "multicall",
        outputs: [
            {
                internalType: "bytes[]",
                name: "",
                type: "bytes[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "onERC721Received",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "uint128",
                                name: "marketId",
                                type: "uint128",
                            },
                            {
                                internalType: "uint128",
                                name: "accountId",
                                type: "uint128",
                            },
                            {
                                internalType: "int128",
                                name: "sizeDelta",
                                type: "int128",
                            },
                            {
                                internalType: "uint128",
                                name: "settlementStrategyId",
                                type: "uint128",
                            },
                            {
                                internalType: "uint256",
                                name: "acceptablePrice",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct IEngine.OrderDetails",
                        name: "orderDetails",
                        type: "tuple",
                    },
                    {
                        internalType: "address",
                        name: "signer",
                        type: "address",
                    },
                    {
                        internalType: "uint128",
                        name: "nonce",
                        type: "uint128",
                    },
                    {
                        internalType: "bool",
                        name: "requireVerified",
                        type: "bool",
                    },
                    {
                        internalType: "address",
                        name: "trustedExecutor",
                        type: "address",
                    },
                    {
                        internalType: "bytes[]",
                        name: "conditions",
                        type: "bytes[]",
                    },
                ],
                internalType: "struct IEngine.ConditionalOrder",
                name: "_co",
                type: "tuple",
            },
        ],
        name: "verifyConditions",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "uint128",
                                name: "marketId",
                                type: "uint128",
                            },
                            {
                                internalType: "uint128",
                                name: "accountId",
                                type: "uint128",
                            },
                            {
                                internalType: "int128",
                                name: "sizeDelta",
                                type: "int128",
                            },
                            {
                                internalType: "uint128",
                                name: "settlementStrategyId",
                                type: "uint128",
                            },
                            {
                                internalType: "uint256",
                                name: "acceptablePrice",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct IEngine.OrderDetails",
                        name: "orderDetails",
                        type: "tuple",
                    },
                    {
                        internalType: "address",
                        name: "signer",
                        type: "address",
                    },
                    {
                        internalType: "uint128",
                        name: "nonce",
                        type: "uint128",
                    },
                    {
                        internalType: "bool",
                        name: "requireVerified",
                        type: "bool",
                    },
                    {
                        internalType: "address",
                        name: "trustedExecutor",
                        type: "address",
                    },
                    {
                        internalType: "bytes[]",
                        name: "conditions",
                        type: "bytes[]",
                    },
                ],
                internalType: "struct IEngine.ConditionalOrder",
                name: "_co",
                type: "tuple",
            },
            {
                internalType: "bytes",
                name: "_signature",
                type: "bytes",
            },
        ],
        name: "verifySignature",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "uint128",
                                name: "marketId",
                                type: "uint128",
                            },
                            {
                                internalType: "uint128",
                                name: "accountId",
                                type: "uint128",
                            },
                            {
                                internalType: "int128",
                                name: "sizeDelta",
                                type: "int128",
                            },
                            {
                                internalType: "uint128",
                                name: "settlementStrategyId",
                                type: "uint128",
                            },
                            {
                                internalType: "uint256",
                                name: "acceptablePrice",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct IEngine.OrderDetails",
                        name: "orderDetails",
                        type: "tuple",
                    },
                    {
                        internalType: "address",
                        name: "signer",
                        type: "address",
                    },
                    {
                        internalType: "uint128",
                        name: "nonce",
                        type: "uint128",
                    },
                    {
                        internalType: "bool",
                        name: "requireVerified",
                        type: "bool",
                    },
                    {
                        internalType: "address",
                        name: "trustedExecutor",
                        type: "address",
                    },
                    {
                        internalType: "bytes[]",
                        name: "conditions",
                        type: "bytes[]",
                    },
                ],
                internalType: "struct IEngine.ConditionalOrder",
                name: "_co",
                type: "tuple",
            },
        ],
        name: "verifySigner",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
export class MarginEngine__factory {
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
MarginEngine__factory.abi = _abi;
